import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cx_access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      const refresh = localStorage.getItem("cx_refresh_token");
      if (refresh) {
        original._retry = true;
        try {
          if (!refreshing) {
            refreshing = axios.post(`${API}/auth/refresh`, { refresh_token: refresh });
          }
          const { data } = await refreshing;
          refreshing = null;
          const newToken = data.data.access_token;
          localStorage.setItem("cx_access_token", newToken);
          original.headers.Authorization = `Bearer ${newToken}`;
          return api(original);
        } catch (e) {
          refreshing = null;
          localStorage.removeItem("cx_access_token");
          localStorage.removeItem("cx_refresh_token");
        }
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e, fallback = "Si è verificato un errore. Riprova.") {
  const err = e?.response?.data?.error;
  if (err?.message) return err.message;
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || JSON.stringify(d)).join(" ");
  return e?.message || fallback;
}

export default api;
